var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7959 17.1775V12.1775C21.7959 7.20693 17.7665 3.17749 12.7959 3.17749C7.82534 3.17749 3.7959 7.20693 3.7959 12.1775V17.1775",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7959 15.6775V17.6775",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7959 15.6775V17.6775",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7959 14.0221C8.7959 13.2577 8.7959 12.8755 8.62116 12.6098C8.53323 12.476 8.41651 12.3655 8.28029 12.287C8.00961 12.131 7.64402 12.1671 6.91284 12.2392C5.68077 12.3606 5.06474 12.4214 4.62327 12.7539C4.39984 12.9222 4.21227 13.1368 4.07236 13.3842C3.7959 13.873 3.7959 14.517 3.7959 15.8051V17.3708C3.7959 18.646 3.7959 19.2836 4.07787 19.776C4.18342 19.9604 4.31571 20.1266 4.47006 20.2688C4.88242 20.6488 5.48434 20.7675 6.68817 21.0049C7.53534 21.172 7.95892 21.2555 8.27154 21.0796C8.38689 21.0147 8.48886 20.9268 8.57162 20.8209C8.7959 20.534 8.7959 20.0853 8.7959 19.1879V14.0221Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7959 14.0221C16.7959 13.2577 16.7959 12.8755 16.9706 12.6098C17.0586 12.476 17.1753 12.3655 17.3115 12.287C17.5822 12.131 17.9478 12.1671 18.679 12.2392C19.911 12.3606 20.5271 12.4214 20.9685 12.7539C21.192 12.9222 21.3795 13.1368 21.5194 13.3842C21.7959 13.873 21.7959 14.517 21.7959 15.8051V17.3708C21.7959 18.646 21.7959 19.2836 21.5139 19.776C21.4084 19.9604 21.2761 20.1266 21.1217 20.2688C20.7094 20.6488 20.1075 20.7675 18.9036 21.0049C18.0565 21.172 17.6329 21.2555 17.3203 21.0796C17.2049 21.0147 17.1029 20.9268 17.0202 20.8209C16.7959 20.534 16.7959 20.0853 16.7959 19.1879V14.0221Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUs.1211ead0925d81f701241bb5b0210dc1.svg";
export { ForwardRef as ReactComponent };